import { render } from "./TheFooter.vue?vue&type=template&id=3a853900&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=3a853900&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a853900"
/* hot reload */
if (module.hot) {
  script.__hmrId = "3a853900"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a853900', script)) {
    api.reload('3a853900', script)
  }
  
  module.hot.accept("./TheFooter.vue?vue&type=template&id=3a853900&scoped=true", () => {
    api.rerender('3a853900', render)
  })

}

script.__file = "src/layout/TheFooter.vue"

export default script